





























import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'
import calculatorStore from '@/stores/CalculateStore'
import CalculatorDeliveries from '@/components/calculator/CalculatorResult/CalculatorDeliveries.vue'

@Component({
  components: { CalculatorDeliveries },
})
export default class CalculatorResult extends Vue {
  calculatorStore = calculatorStore
}
